import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/pin.tsx
var Pin = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M12 15H5V13.2645C5 12.775 5.19444 12.3056 5.54054 11.9595C6.79516 10.7049 7.5 9.00324 7.5 7.22894V5.00003C7.5 3.89546 8.39543 3.00003 9.5 3.00003H14.5C15.6046 3.00003 16.5 3.89546 16.5 5.00003V7.22894C16.5 9.00324 17.2048 10.7049 18.4595 11.9595C18.8056 12.3056 19 12.775 19 13.2645V15H12ZM12 15V21",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M9.83569 3C8.46388 3 7.35181 4.13651 7.35181 5.53846V7.59591C7.35181 9.05012 6.78656 10.4448 5.78039 11.473C5.34074 11.9224 5.09375 12.5318 5.09375 13.1672V14.7692C5.09375 15.1516 5.39704 15.4615 5.77117 15.4615H11.4163V20.3077C11.4163 20.69 11.7196 21 12.0938 21C12.4679 21 12.7712 20.69 12.7712 20.3077V15.4615H18.4163C18.7905 15.4615 19.0938 15.1516 19.0938 14.7692V13.1672C19.0938 12.5318 18.8468 11.9224 18.4071 11.473C17.4009 10.4448 16.8357 9.05012 16.8357 7.59591V5.53846C16.8357 4.13651 15.7236 3 14.3518 3H9.83569Z",
		fill: "currentColor"
	})
});
//#endregion
export { Pin };
